import { styled } from '@mui/material/styles';

export const SearchContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  gridTemplateColumns:
    'minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(80px, 120px)',
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  minWidth: 0,
}));

export const SearchFilterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  gap: theme.spacing(2),
  flexWrap: 'nowrap',
  minWidth: 0,
  overflow: 'visible',
  position: 'relative',
}));
